import { Component, Signal } from '@angular/core';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { selectPending } from '../../../store/selectors/surveys.selectors';
import { SurveyBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead } from '../../../openapi';
import { SurveyForm } from './forms/survey.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../common/validation-errors/validation-errors.component';
import { sendAnswer } from '../../../store/actions/surveys.actions';
import { AlertComponent } from '../../../common/alert/alert.component';
import { SessionService } from '../../../services/ssession.service';
import { LabelComponent } from '../../../common/label/label.component';

@Component({
  selector: 'app-survey-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    AlertComponent,
    RouterLink,
    LabelComponent
  ],
  providers: [SurveyForm],
  templateUrl: './survey-page.component.html'
})
export class SurveyPageComponent {

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public survey: SurveyBaseAllBaseReadSurveyAllSurveyReadSurveyItemRead = this.route.snapshot.data['survey'];

  public authed: boolean = SessionService.Authed();

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private router: Router,
    public form: SurveyForm
  ) {
    if (!this.survey?.publishResults) {
      this.survey?.surveyQuestions?.forEach(v => {
        this.form.addQuestionGroup(v);
      });
    }
  }

  public onSubmit(): void {
    if (this.form.valid) {
      this.store$.dispatch(sendAnswer({
        items: this.form.values,
        successFunc: () => {
          this.router.navigate(['./../'], {
            state: { successMessage: 'Dziekuję! Twoja ankieta została wysłana.' },
            relativeTo: this.route
          });
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

}
